module.exports = __webpack_public_path__ + "static/img/haoqi.b155c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/haoqi.png
// module id = TAm7
// module chunks = 0